import type { ListBuilderList } from '../../../types';

/**
 * Expired list - licenses that have lapsed and need renewal action.
 *
 * Defaults to the last 90 days — the same window the compliance dashboard
 * "Recently Expired" KPI uses, so the click-through count matches the KPI
 * value. A license that lapsed years ago is a data-cleanup/match task, not
 * a renewal to chase; the date filter stays visible and editable for
 * officers who want the full expired population.
 *
 * Sorted by most recently expired first so compliance officers can
 * prioritize clients that just fell out of compliance.
 */
export const expiredList: ListBuilderList = {
	id: 'default-licenses-expired',
	cacheTTL: 300000,
	name: 'Expired',
	type: 'default',
	active: true,
	sortOrder: 3,
	filterRules: {
		licenseStatus: {
			defaultValue: [{ id: 'Expired', label: 'Expired' }],
			locked: true,
			hidden: true,
		},
		licenseExpirationDateRange: {
			defaultValue: [
				{
					id: 'last90days',
					label: 'Last 90 Days',
					data: {
						startDate: '{{DATE:-90d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'column-license-expiration-desc',
	inheritsFrom: 'default-licenses-all',
};
